(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-creacion-pedido"]) return;
  try {
    
  class CheckoutForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('#checkout-form');
      this.submitBtn = this.querySelector('#submitBtn');
      
      // Doc Type custom select
      this.docTypeBtn = this.querySelector('#docTypeBtn');
      this.docTypeList = this.querySelector('#docTypeList');
      this.docTypeVal = this.querySelector('#docTypeVal');
      this.docTypeInput = this.querySelector('#docType');
      
      this.bindEvents();
    }
    
    bindEvents() {
      // DocType Toggle
      if (this.docTypeBtn && this.docTypeList) {
        this.docTypeBtn.addEventListener('click', (e) => {
          const isExpanded = this.docTypeBtn.getAttribute('aria-expanded') === 'true';
          this.docTypeBtn.setAttribute('aria-expanded', !isExpanded);
          if (isExpanded) {
            this.docTypeList.setAttribute('hidden', '');
          } else {
            this.docTypeList.removeAttribute('hidden');
          }
        });
        
        const docItems = this.docTypeList.querySelectorAll('[role="option"]');
        docItems.forEach(item => {
          item.addEventListener('click', () => {
            const val = item.dataset.value;
            docItems.forEach(i => i.setAttribute('aria-selected', 'false'));
            item.setAttribute('aria-selected', 'true');
            if (this.docTypeVal) this.docTypeVal.textContent = val;
            if (this.docTypeInput) this.docTypeInput.value = val;
            this.docTypeList.setAttribute('hidden', '');
            this.docTypeBtn.setAttribute('aria-expanded', 'false');
          });
        });
        
        document.addEventListener('click', (e) => {
          const wrapper = this.querySelector('#docTypeWrapper');
          if (wrapper && !wrapper.contains(e.target)) {
            this.docTypeBtn.setAttribute('aria-expanded', 'false');
            this.docTypeList.setAttribute('hidden', '');
          }
        });
      }

      // Form Submit
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      // Sincronización en tiempo real del carrito
      document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
    }
    
    async handleSubmit(e) {
      e.preventDefault();
      
      if (!this.form.checkValidity()) {
        if (typeof window.showPuntazoToast === 'function') {
          window.showPuntazoToast('Por favor completa todos los campos obligatorios.', 'error');
        } else {
          alert('Por favor completa todos los campos obligatorios.');
        }
        this.form.reportValidity();
        return;
      }
      
      this.submitBtn.disabled = true;
      const originalText = this.submitBtn.innerHTML;
      this.submitBtn.innerHTML = 'Procesando...';
      
      try {
        const formData = new FormData(this.form);
        const data = Object.fromEntries(formData.entries());
        
        // 1. Fetch Cart Items
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        
        if (cart.items.length === 0) {
          if (typeof window.showPuntazoToast === 'function') {
            window.showPuntazoToast('Tu carrito está vacío.', 'error');
          }
          window.location.href = '/cart';
          return;
        }
        
        // 2. Create Draft Order via n8n Webhook
        const payload = {
          customer_info: {
            nombre: data.first_name,
            apellido: data.last_name, // Compatibilidad con el payload (ahora el nombre y apellido van en first_name)
            email: data.email,
            cedula: `${data.doc_type}-${data.doc_number}`,
            telefono: data.phone,
            empresa: data.company || '',
            observaciones: data.notes || ''
          },
          items: cart.items,
          total_price: cart.total_price
        };

        const response = await fetch('https://mi-n8n-tienda.onrender.com/webhook/3838b19f-cf35-4022-953c-478e3a15075f', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) { throw new Error('Error en el servidor de procesado'); }

        const dataResponse = await response.json();

        if (dataResponse.success) {
          const telefonoTienda = "584128813115"; 
          const mensajeWhatsApp = `Hola, acabo de generar mi orden de compra. Mi nombre es ${dataResponse.customer_name || data.first_name} y mi número de pedido es el #${dataResponse.order_number}.`;
          
          const overlay = document.getElementById('checkoutSuccessOverlay');
          if (overlay) {
            overlay.setAttribute('aria-hidden', 'false');
            // Trigger reflow to start animations
            void overlay.offsetWidth;
            overlay.classList.add('is-active');
            
            // Wait for animations (approx 3 seconds)
            setTimeout(async () => {
              // Clear Cart
              await fetch('/cart/clear.js', { method: 'POST' });
              
              // Redirect to WA
              const whatsappUrl = `https://wa.me/${telefonoTienda}?text=${encodeURIComponent(mensajeWhatsApp)}`;
              window.location.href = whatsappUrl;
            }, 3000);
          } else {
            // Fallback just in case
            await fetch('/cart/clear.js', { method: 'POST' });
            const whatsappUrl = `https://wa.me/${telefonoTienda}?text=${encodeURIComponent(mensajeWhatsApp)}`;
            window.location.href = whatsappUrl;
          }
        } else {
          throw new Error('Respuesta inválida al crear el pedido');
        }
        
      } catch (error) {
        console.error('Error procesando pedido', error);
        if (typeof window.showPuntazoToast === 'function') {
          window.showPuntazoToast('Hubo un error al procesar tu pedido. Por favor intenta nuevamente.', 'error');
        } else {
          alert('Hubo un error al procesar tu pedido. Por favor intenta nuevamente.');
        }
        this.submitBtn.disabled = false;
        this.submitBtn.innerHTML = originalText;
      }
    }

    handleCartUpdate(e) {
      if (!e.detail || !e.detail.items) return;
      const cart = e.detail;
      const summaryItems = this.querySelectorAll('.summary-item');
      
      summaryItems.forEach(itemEl => {
        const key = itemEl.dataset.itemKey;
        const cartItem = cart.items.find(i => i.key === key);
        
        if (!cartItem) {
          // El producto fue eliminado
          itemEl.remove();
        } else {
          // Actualizar cantidad y precio
          const qtyEl = itemEl.querySelector('[data-item-qty]');
          const priceEl = itemEl.querySelector('[data-item-price]');
          if (qtyEl) qtyEl.textContent = `Cant. ${cartItem.quantity}`;
          if (priceEl) priceEl.textContent = this.formatMoney(cartItem.final_line_price);
        }
      });
      
      // Actualizar totales
      const totalEl = this.querySelector('[data-cart-total]');
      if (totalEl) {
        totalEl.innerHTML = `${this.formatMoney(cart.total_price)} <span class="summary-total__currency">${cart.currency}</span>`;
      }
      
      // Si el carrito está vacío, redirigir
      if (cart.item_count === 0) {
        window.location.href = '/cart';
      }
    }

    formatMoney(cents) {
      const value = (cents / 100).toFixed(2);
      // Quitar los .00 si es entero (para emular money_without_trailing_zeros)
      const cleanValue = value.endsWith('.00') ? value.slice(0, -3) : value;
      return '$' + cleanValue;
    }
  }
  
  if (!customElements.get('checkout-form')) {
    customElements.define('checkout-form', CheckoutForm);
  }

  } catch(e) { console.error(e); }
})();
})();
